import {isEqual, isObject, transform} from 'lodash';


class HelpersService {
	// Used to diff 2 objects, from: https://gist.github.com/Yimiprod/7ee176597fef230d1451
	diff(object: any, base: any) {
		return transform(object, (result: any, value, key) => {
			if (!isEqual(value, base[key])) {
				result[key] = (isObject(value) && isObject(base[key])) ? this.diff(value, base[key]) : value;
			}
		}, {});
	}
}

export const Helpers = new HelpersService();
